<template>
    <div id="task-modal">
        <input
            :placeholder="$t('calendar.title')"
            class="event-input"
            v-model="eventModalData.summary"
        />
        <div class="info">
            <span class="material-icons single">access_time</span>
            <a-date-picker class="single" v-model:value="eventModalData.startDate" :format="customFormat" />
            <div style="display: flex">
                <a-time-picker class="single" v-model:value="eventModalData.startTime" format="HH:mm"></a-time-picker>
            </div>
        </div>
        <div class="info">
            <a-checkbox v-model="eventModalData.isAllDay" style="width: 100px">{{ $t("calendar.allDay") }}</a-checkbox>
            <a-select v-model="eventModalData.repeat" show-search style="width: 100%">
                <a-select-option v-for="(repeatTime, index) of repeatTimes" :key="index" :value="repeatTime.value">
                    {{ repeatTime.label }}
                </a-select-option>
            </a-select>
        </div>
        <div class="info">
            <span class="material-icons">subject</span>
            <a-input
                :placeholder="$t('message.description')"
                class="description"
                v-model="eventModalData.description"
            />
        </div>
        <div class="footer-action">
            <span class="btn delete" @click="deleteEvent()" v-if="Object.keys(this.eventDetail).length > 0">{{
                $t("message.delete")
            }}</span>
            <span class="btn" @click="$emit('close')">{{ $t("calendar.cancel") }}</span>
            <span class="btn" @click="editOrCreateEvent()">{{ $t("calendar.save") }}</span>
        </div>
    </div>
</template>

<script>
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { log2 } from "../../../../utils/log2";
import { getExtensionFromFileName } from "../../../../utils/utils";
import { uploadAsset } from "../../../../api/assetUpload";
import mimeTypes from "../../../../components/util/mimeTypes";
import axios from "axios";
import moment from "moment";
import _ from "lodash";

moment.locale("tr");
const log = log2("TaskModal");
export default {
    name: "TaskModal",
    components: {
        AppBreadCrumb,
    },
    props: {
        repeatTimes: {
            type: Array,
            default: () => [],
        },
        selectedDate: {
            type: Date,
            default: "",
        },
        eventDetail: {
            type: Object,
            default: () => {},
        },
        eventFunction: {
            type: Function,
        },
    },
    data() {
        return {
            eventModalData: {},
            modalBaseData: {
                summary: "",
                refUsers: [],
                repeat: "not_repeat",
                isAllDay: false,
                startDate: "",
                startTime: "",
                visibility: "public",
                description: "",
            },
            customFormat: "YYYY-MM-DD",
            newEventModalVisible: false,
            fileLoading: 0,
            attachments: [],
            assetIds: [],
            isEdit: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
        deleteEvent() {
            this.$confirm({
                title: "Kaydı sil",
                content: "Kaydı slimek istediğinizden emin misiniz?",
                okText: "Sil",
                okType: "danger",
                cancelText: "Kapat",
                onOk: async () => {
                    console.log("deleteEvent this.eventModalData._id", this.eventModalData._id);
                    this.$emit("delete-event", this.eventModalData._id);
                },
            });
        },
        deleteAttachment(index) {
            this.attachments = this.attachments.filter((attachment, i) => i !== index);
        },
        async editOrCreateEvent() {
            if (this.eventModalData.summary === "") {
                this.$message.error("Başlık boş bırakılamaz!");
                return false;
            }
            let data = this.eventModalData;
            data.startTime = moment(data.startTime).format("HH:mm");
            data.userId = this.user._id;
            data.type = "task";
            data.isEdit = this.isEdit;
            data.refUsers = this.refUsers;
            await this.eventFunction(data);
        },
        async selectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute("multiple", "multiple");
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                for (let i = 0; i < fileEl.files.length; i++) {
                    if (file.size <= 20 * 1024 * 1024) {
                        let uploadFile = {
                            fileNumber: Math.random(),
                            finished: false,
                            percent: 0,
                            failed: false,
                        };
                        await this.uploadFile(fileEl.files[i], uploadFile);
                    } else {
                        log.warn("input is not suitable for send");
                        this.$toasted.error(this.$t("message.assetOversizeWithExt"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                    }
                }
            };
            fileEl.click();
        },
        async uploadFile(file, uploadFile) {
            this.fileLoading = 0;
            const newSize = (file.size / 100).toFixed(2);
            const fileId = this.attachments.length + 1;
            this.attachments.push({ file, newSize, fileId });
            console.log("uploadFile this.attachments", this.attachments);

            const fileType = getExtensionFromFileName(file.name);
            let path = `${this.site._id}/calendar/attachments/`;

            let { data } = await uploadAsset({
                path,
                mime: file.type,
                ext: mimeTypes[file.type] || fileType || "supsis",
                name: file.name,
                size: file.size,
                type: "calendar",
            });
            this.assetIds.push(data.asset.id);

            if (file.size <= 10 * 1024 * 1024) {
                await axios({
                    method: data.method,
                    url: data.url,
                    data: file,
                    headers: {
                        "Content-Type": file.type,
                    },
                    onUploadProgress: await function (progressEvent) {
                        this.fileLoading = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    }.bind(this),
                }).then((res) => {
                    console.log("created asset res", res);
                });
            } else {
                log.warn("input is not suitable for send");
                this.$toasted.error(this.$t("message.assetOversize"), {
                    duration: 3000,
                    position: "bottom-center",
                });
            }
        },
    },
    async mounted() {
        if (Object.keys(this.eventDetail).length > 0) {
            this.eventDetail.startTime = moment(this.eventDetail.startTime, "HH:mm");
            this.eventDetail.startDate = moment(this.eventDetail.startDate);

            this.eventModalData = this.eventDetail;
            this.isEdit = true;
        } else {
            this.eventModalData = _.cloneDeep(this.modalBaseData);
            this.eventModalData.startDate = this.selectedDate;
            this.isEdit = false;
        }
    },
    watch: {
        selectedDate(val) {
            this.eventModalData = _.cloneDeep(this.modalBaseData);
            this.eventModalData.startDate = val;
        },
        eventDetail(val) {
            if (Object.keys(val).length > 0) {
                this.eventDetail.startTime = moment(this.eventDetail.startTime, "HH:mm");
                this.eventDetail.startDate = moment(this.eventDetail.startDate);
                this.eventModalData = val;
                this.isEdit = true;
            } else {
                this.isEdit = false;
            }
        },
    },
};
</script>

<style lang="scss">
.ant-select-selection {
    background-color: white !important;
}
</style>

<style lang="scss" scoped>
.fc-view-harness.fc-view-harness-active {
    max-height: 500px;
}

.modal-container {
    width: 95%;

    .event-input {
        margin-top: 15px;
        width: 100%;
        border: none;
        border-bottom: 0.5px solid grey;
        margin-bottom: 10px;

        &:hover {
            border-bottom: 1px solid #021eb6;
        }
    }

    .tags {
        display: flex;
        align-items: center;

        .tag {
            color: rgb(109, 117, 131);
            padding: 5px;
            border-radius: 5px;
            font-size: 12px;
            font-weight: 500;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
                background-color: #e8e8e8;
            }

            &.selected {
                background-color: rgb(210, 227, 252);
                color: rgb(66, 133, 244);
            }
        }
    }

    .single {
        margin-right: 5px;
    }

    .info {
        margin-top: 15px;
        display: flex;
        align-items: center;
    }

    .attachments {
        .attachment {
            margin-bottom: 5px;
            background-color: aliceblue;
            padding: 3px;
            border-radius: 5px;
        }
    }

    .description {
        margin-left: 10px;
    }

    .attach-icon {
        font-size: 20px;
    }

    .attachment {
        display: flex;
        align-items: center;
    }

    .lock-icon {
        font-size: 20px;
        margin-right: 10px;
    }

    .attache_file_btn {
        border: none;
        padding: 5px;
        border-radius: 5px;
        background-color: white;

        &:hover {
            background-color: #e8e8e8 !important;
        }
    }
}

#task-modal {
    background-color: #ffffff;
    height: 100%;

    .event-input {
        width: 100%;
        border: none;
        border-bottom: 0.5px solid grey;
        margin-bottom: 10px;

        &:hover {
            border-bottom: 1px solid #021eb6;
        }
    }

    .footer-action {
        display: flex;
        justify-content: end;
        border-top: 0.5px solid black;
        margin-top: 20px;

        .btn {
            background-color: rgb(66, 133, 244);
            color: white;
            padding: 5px;
            margin: 5px;
            border-radius: 10px;

            &.delete {
                background-color: #ff4d4f;
            }
        }
    }
}
</style>
